export default {
    path: '/title-assignment/:productCode?',
    name: 'TitleAssignment',
    component: () => import( /* webpackChunkName: "TitleAssignment" */ '@/views/TitleResearch/Assignment' ),
    meta: {
        requiresAuth: true,
        title: 'Title Assignment',
        documentTitle: 'Title Assignment',
    },
};
